import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import React from 'react';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Toolbar from '@material-ui/core/Toolbar';

const useStyles = makeStyles((theme: Theme) => ({
  backButton: {
    marginRight: theme.spacing(1),
  },
  buttonsTop: {
    backgroundColor: 'inherit',
  },
  buttonSection: {
    margin: 'auto',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    overflow: 'hidden',
    backgroundColor: theme.palette.common.white,
  },
  root: {
    height: '100%',
  },
  hidden: {
    display: 'none',
  },
}));

export interface VseCourseNewButtonsProps {
  viewOnly: boolean,
  onBackClick: () => void,
  onSaveClick: () => void,
};

export function VseCourseNewButtons(props: VseCourseNewButtonsProps) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const showSaveButton = (props.viewOnly || (props.viewOnly === undefined)) ? false : true;
  return (
    <div className={classes.buttonSection}>
      <Box displayPrint="none">
        <AppBar className={classes.buttonsTop} position="static" elevation={0}>
          <Toolbar>
            <ButtonGroup variant="contained" >
              <Button variant="contained" color="primary" className={clsx(!showSaveButton && classes.hidden)}
                onClick={() => {
                  props.onSaveClick();
                }}>
                Save
              </Button>
              <Button variant="contained" onClick={() => {
                props.onBackClick();
              }}>
                Back
              </Button>
            </ButtonGroup>
          </Toolbar>
        </AppBar>
      </Box>
    </div >
  );
}
